import React, { FC, useEffect } from 'react';
import { ROLE_TYPES } from '../../../utils/DataConstants';
import {
	workOrdersRestCrudThunksForBuyer,
	workOrdersRestCrudThunksForSupplier,
} from '../../../thunks/work_orders_thunks';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import { withUserType } from '../../withUserType';
import { PageLoadingPlaceholder } from '../../page_loading_placeholder/PageLoadingPlaceholder';
import { Route, Redirect } from 'react-router-dom';
import RouteWithSubRoutes from '../../route_with_sub_routes/RouteWithSubRoutes';

const WorkOrderNotificationPage: FC<any> = ({
	match,
	getWorkOrder,
	workOrderFetching,
	childRoutes,
	userType,
}): React.ReactElement => {
	const workOrderId = match.params.id;

	useEffect(() => {
		getWorkOrder(workOrderId);
	}, []);

	return workOrderFetching ? (
		<PageLoadingPlaceholder />
	) : (
		<div>
			<Route
				path={`/${userType}/workorder_notifications/${workOrderId}`}
				exact={true}
				render={(props) => (
					<Redirect
						to={{
							pathname: `/${userType}/workorder_notifications/${workOrderId}/unsubscribe`,
						}}
					/>
				)}
			/>
			{childRoutes.map((r, i) => (
				<RouteWithSubRoutes key={i} {...r} />
			))}
		</div>
	);
};

const mapStateToProps = (state) => ({
	workOrderFetching: state.work_orders.fetching,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	getWorkOrder: (id) =>
		dispatch(
			ownProps.userType === ROLE_TYPES.SUPPLIER
				? workOrdersRestCrudThunksForSupplier.readOne(id)
				: workOrdersRestCrudThunksForBuyer.readOne(id)
		),
});

export default withRouter<any, any>(
	withUserType(connect(mapStateToProps, mapDispatchToProps)(WorkOrderNotificationPage))
);
